import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { EResourceViewMode } from 'app/shared/resource-view-mode.const';

import { CostLayerComponent } from './components/cost-layer/cost-layer.component';
import { CostLayerEditComponent } from './components/cost-layer-edit/cost-layer-edit.component';
import { CostLayerInfoComponent } from './components/cost-layer-info/cost-layer-info.component';
import { CostLayersComponent } from './components/cost-layers.component';

const routes :Routes = [
  {
    path: '',
    component: CostLayersComponent,
  },
  {
    path: 'create',
    component: CostLayerComponent,
    children: [
      {
        path: '',
        component: CostLayerEditComponent,
        data: { viewMode: EResourceViewMode.CREATE },
      },
    ],
  },
  {
    path: ':id',
    component: CostLayerComponent,
    children: [
      {
        path: '',
        component: CostLayerInfoComponent,
        data: { viewMode: EResourceViewMode.READ },
      },
      {
        path: 'edit',
        component: CostLayerEditComponent,
        data: { viewMode: EResourceViewMode.UPDATE },
      },
    ],
  },
];

@NgModule({
  declarations: [],
  imports: [RouterModule.forChild(routes)],
})
export class CostLayersRoutingModule {}
